<template>
    <div class="col-md-5 mt-10 pa-0 white-container d-flex flex-row justify-space-between">
        <div class="pa-5 d-flex flex-row flex-column flex-wrap justify-space-around">
            <v-img v-if="integration.logo" max-height="39px" max-width="135px" :src="$root.getSrc(integration.logo)" contain></v-img>
            <p class="ma-0 pt-10 fw-600 fs-18" v-if="integration.short_description">
                {{integration.short_description}}
            </p>
<!--            <p v-if="integration.long_description" class="ma-0 pt-5 fw-400 fs-14" v-html="integration.long_description"></p>-->
            <primary-button @clickBtn="startIntegration()" class="mt-10" :activeButton="checkIfIsConnectable(integration)">Connect</primary-button>
        </div>
        <v-spacer></v-spacer>
        <v-img v-if="integration.image" max-height="311px" max-width="212px" :src="$root.getSrc(integration.image)" contain></v-img>
        <v-dialog :width="($vuetify.breakpoint.mdAndUp)? '50%' : '95%'" >
            <template v-slot:activator="{on}">
                <button v-on="on" ref="activateDialog"></button>
            </template>
            <v-card>
                <v-card-title>Integration instruction</v-card-title>
                <v-card-text class="body-1 pb-10">
                    <div v-html="integration.connectInstruction"></div>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-spacer></v-spacer>
                    <v-btn color="red" class="white--text" @click="$refs.activateDialog.click()">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        props:['integration'],
        methods:{
            checkIfIsConnectable(integration){
                if(!this.$integrations.userIntegrations) return false;
                let check = false;
                for(var i in this.$integrations.userIntegrations){
                    if(i == integration.type && this.$integrations.userIntegrations[i] != null){
                        check = true;
                    }
                }
                return !check;
            },
            startIntegration(){
                if(this.integration.connectInstruction){
                    this.$refs.activateDialog.click();
                }else{
                    this.$router.push('/integration/'+integration.type);
                }
            }
        }
    }
</script>
